import { Controller } from "stimulus"
import { createPopper } from '@popperjs/core';

export default class extends Controller {
  static targets = ['popover', 'button', 'picker']
  static values = { textareaSelector: String }

  connect() {
    this.textarea = $(this.textareaSelectorValue)
    this.popper = createPopper(this.buttonTarget, this.popoverTarget)
    this.pickerTarget.addEventListener('emoji-click', this.emojiSelected.bind(this))
  }

  toggle() {
    this.popoverTarget.classList.toggle('shown')
    this.popper.update()
  }

  emojiSelected(event) {
    this.textarea.val(this.textarea.val() + event.detail.unicode)
  }
}
